var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll-lock",
          rawName: "v-scroll-lock",
          value: _vm.isVisible && !_vm.isMobile,
          expression: "isVisible && !isMobile",
        },
      ],
      staticClass: "rb-virtual-mirror",
      class: { "rb-virtual-mirror--is-visible": _vm.isVisible },
    },
    [
      _c("div", {
        staticClass: "rb-virtual-mirror__vmmv",
        class: { "rb-virtual-mirror__vmmv--is-visible": _vm.isVisible },
      }),
      _vm._v(" "),
      _vm.roxPanelIsVisible ? _c("rb-rox-panel") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }